webpackJsonp([15400075347947],{

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Meta = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _root, _content;
	
	  return {
	    root: (_root = {
	      padding: 50
	    }, _root[theme.breakpoints.down('sm')] = {
	      padding: 10
	    }, _root),
	    content: (_content = {
	      width: 900,
	      margin: 'auto'
	    }, _content[theme.breakpoints.down('sm')] = {
	      width: '90%'
	    }, _content)
	  };
	};
	
	var PrivacyPolicyPage = function PrivacyPolicyPage(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	  var page = data.page,
	      siteMetadata = data.site.siteMetadata;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.root },
	    _react2.default.createElement(_Meta.RootMeta, {
	      url: siteMetadata.siteUrl + '/privacy-policy',
	      title: 'Privacy Policy | ' + siteMetadata.siteName
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: classes.content },
	      _react2.default.createElement(
	        _Typography2.default,
	        {
	          align: 'center',
	          variant: 'headline',
	          style: { fontWeight: 500 },
	          gutterBottom: true,
	          paragraph: true
	        },
	        'PRIVACY POLICY'
	      ),
	      _react2.default.createElement(_Typography2.default, { dangerouslySetInnerHTML: { __html: page.html } })
	    )
	  );
	};
	
	PrivacyPolicyPage.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object.isRequired
	
	  // prettier-ignore
	  // eslint-disable-next-line
	};var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = (0, _withStyles2.default)(styles)(PrivacyPolicyPage);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-js-cbc2b2a664f9165fd978.js